import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Check1 = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      stroke={iconColor}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{iconTitle}</title>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
};

Check1.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Check1.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};
export default withTheme(Check1);
